import { apiClient } from '@services/api-client'

import {
  settlementsUrl,
  useSettlementMutation
} from './useSettlementMutation'
import type { PublishPayload, SettlementDetail } from '../types'

/**
 * Publishing freezes the computed result and makes it visible to the tenant.
 * Blocking checks refuse unless `force` is sent with a reason.
 */
export function usePublishSettlement() {
  return useSettlementMutation<
    { id: string; body?: PublishPayload },
    SettlementDetail
  >({
    toastKey: 'settlementPublished',
    request: async ({ id, body }) =>
      (
        await apiClient.post<SettlementDetail>(
          `${settlementsUrl}/${id}/publish`,
          body ?? {}
        )
      ).data
  })
}
